/**
 * TripodSelectionHandler
 * TRIPOD Entity 타입의 선택 핸들러 로직
 * TripodSelectionMixin의 __addTripodHandler()를 호출하는 래퍼입니다.
 */

import type { SelectionStrategy } from '../../base/selectionStrategy'
import type { BaseSelectionHandler } from '../../base/baseSelectionHandler'

export class TripodSelectionHandler implements SelectionStrategy {
  /**
   * TRIPOD 타입 선택 핸들러 추가
   * TripodSelectionMixin의 __addTripodHandler() 메서드를 호출합니다.
   * @param entity - BaseSelectionHandler 인스턴스
   */
  addHandlers(entity: BaseSelectionHandler): void {
    // TripodSelectionMixin의 __addTripodHandler() 메서드 호출
    const tripodMixin = entity as unknown as { __addTripodHandler: () => void }
    if (tripodMixin.__addTripodHandler) {
      tripodMixin.__addTripodHandler()
    }
  }
}
